import { buildGenericTooltipRows } from './tooltipHelpers';

import {
    type ReportWidgetItem,
    type ReportWidgetItemMeta,
    type ReportWidgetTooltipRowConfig,
    type ReportWidgetTooltipRowsBuilder,
    getChartItemId,
} from '../types';

function getAggregatedCount(meta?: ReportWidgetItemMeta): number | null {
    const count = meta?.aggregatedCount;
    return typeof count === 'number' && count > 0 ? count : null;
}

export function getAggregatedOtherLabel(params?: {
    modelLabel?: string;
    meta?: ReportWidgetItemMeta;
}): string {
    const modelLabel = params?.modelLabel;
    const aggregatedCount = getAggregatedCount(params?.meta);

    if (aggregatedCount != null && modelLabel) {
        return `${aggregatedCount} ${modelLabel}`;
    }

    if (modelLabel) {
        return `Other ${modelLabel}`;
    }

    return 'Other';
}

export function resolvePieTooltipRowsBuilder(params: {
    items: ReportWidgetItem[];
    modelLabel?: string;
    tooltipRowsBuilder?: ReportWidgetTooltipRowsBuilder;
}): ReportWidgetTooltipRowsBuilder {
    const { items, modelLabel, tooltipRowsBuilder } = params;

    return (args) => {
        const entry = args.payload?.[0];
        const pointPayload = entry?.payload as
            | { id?: string; name?: string }
            | undefined;
        const itemId = pointPayload?.id;
        const matchedItem = itemId
            ? items.find((item) => getChartItemId(item) === itemId)
            : undefined;

        if (matchedItem?.meta?.isAggregatedOther) {
            const aggregatedOtherLabel = getAggregatedOtherLabel({
                modelLabel,
                meta: matchedItem.meta,
            });
            const aggregatedHeaderRows: ReportWidgetTooltipRowConfig[] = [
                {
                    id: 'header',
                    variant: 'header',
                    label: aggregatedOtherLabel,
                    boldLabel: true,
                    mutedLabel: true,
                },
            ];

            if (tooltipRowsBuilder) {
                const aggregatedRows = tooltipRowsBuilder({
                    ...args,
                    aggregation: {
                        kind: 'other',
                        label: aggregatedOtherLabel,
                        item: matchedItem,
                        headerRows: aggregatedHeaderRows,
                    },
                });

                if (aggregatedRows && aggregatedRows.length > 0) {
                    return aggregatedRows;
                }
            }

            return aggregatedHeaderRows;
        }

        if (tooltipRowsBuilder) {
            return tooltipRowsBuilder(args) ?? [];
        }

        return buildGenericTooltipRows(args);
    };
}
